import type { WorkspaceService } from '@vnetwork/margarita-shell/iam';
import { compute } from './register-compute';
import { kubernetes } from './register-kubernetes';

/**
 * How each service type maps an organization to its workspace, merged from each module's `workspaceService`
 * (see `createXModule`): the registry `useOrgWorkspaces` runs over and `src/lib/workspace-services.ts` hands to the
 * pages. To add a service type: return a `workspaceService` from its module factory and add one line here. A type
 * appears once.
 */
export const WORKSPACE_SERVICES: readonly WorkspaceService[] = [compute.workspaceService, kubernetes.workspaceService];
